import clsx from 'clsx';
import { FunctionComponent } from 'react';

interface IntroProps {
  firstname: string;
}

const Intro: FunctionComponent<IntroProps> = (props) => {
  const { firstname } = props;

  return (
    <h2 className="text-2xl lg:text-4xl w-full max-w-[550px] lg:max-w-[1100px] m-auto slide-up break-words">
      {firstname && (
        <>
          Hey
          {' '}
          <span className="text-dark-tangerine break-words">{firstname}</span>
          ,
          {' '}
        </>
      )}
      <span className={clsx({ 'inline-block': !firstname, 'capitalize-first': !firstname })}>let&apos;s recap the time we spent together in 2023.</span>
    </h2>
  );
};

export default Intro;
